import React from 'react';

export const CharacterCard = ({
  character,
  onClick,
  onEdit,
  showAspects = true,
  compact = false,
}) => {
  const highConcept = character.aspects?.find(a => a.type === 'high_concept');
  const trouble = character.aspects?.find(a => a.type === 'trouble');

  if (compact) {
    return (
      <div
        className={`
          flex items-center gap-3 p-2 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors
          ${onClick ? 'cursor-pointer' : ''}
        `}
        onClick={onClick}
      >
        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden flex-shrink-0">
          {character.imageUrl ? (
            <img
              src={character.imageUrl}
              alt={character.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-gray-500 text-sm font-medium">
              {character.name?.[0]?.toUpperCase()}
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-900 text-sm truncate">{character.name}</p>
          {highConcept && (
            <p className="text-xs text-gray-500 truncate">{highConcept.name}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`
        bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm
        ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}
      `}
      onClick={onClick}
    >
      {/* Character Image */}
      <div className="aspect-square bg-gray-100 relative">
        {character.imageUrl ? (
          <img
            src={character.imageUrl}
            alt={character.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-4xl text-gray-400 font-medium">
              {character.name?.[0]?.toUpperCase()}
            </span>
          </div>
        )}

        {/* Edit button */}
        {onEdit && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onEdit(character);
            }}
            className="absolute top-2 right-2 p-1.5 bg-white/90 rounded-full shadow hover:bg-white transition-colors"
            title="Edit character"
          >
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
          </button>
        )}
      </div>

      {/* Character Info */}
      <div className="p-3">
        <h3 className="font-semibold text-gray-900 truncate">{character.name}</h3>

        {showAspects && highConcept && (
          <p className="text-sm text-primary-700 mt-1 truncate" title={highConcept.name}>
            {highConcept.name}
          </p>
        )}

        {showAspects && trouble && (
          <p className="text-sm text-red-600 mt-0.5 truncate" title={trouble.name}>
            {trouble.name}
          </p>
        )}

        {character.description && (
          <p className="text-xs text-gray-500 mt-2 line-clamp-2">{character.description}</p>
        )}
      </div>
    </div>
  );
};
